export default __webpack_public_path__ + "static/media/bodyQABg.fec4a87c.png";